import {Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {throttleTime} from 'rxjs/operators';

@Directive({
    selector: '[appThrottledClick]',
    standalone: false
})
export class ThrottledClickDirective implements OnInit, OnDestroy {
    @Input() throttleTime = 500;
    @Output() appThrottledClick = new EventEmitter();

    private clicks = new Subject<Event>();
    private subscription!: Subscription;

    ngOnInit() {
        this.subscription = this.clicks.pipe(
            throttleTime(this.throttleTime)
        ).subscribe(e => this.emitThrottledClick(e));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    emitThrottledClick(e: Event) {
        this.appThrottledClick.emit(e);
    }

    @HostListener('click', ['$event'])
    clickEvent(event: Event) {
        this.clicks.next(event);
    }
}
